import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import logger from '../utils/logger';

const iconSizeBySize = { small: '12px', medium: '16px', large: '20px' };
const iconPad = 4;

const CopyableIdCell = ({ value, label, fallbackText = "None", size = "small", showValue = true }) => {
  const [copied, setCopied] = React.useState(false);
  const hasValue = Boolean(value && value !== 'None' && value !== '');
  const iconSize = iconSizeBySize[size] || iconSizeBySize.small;
  const hitSize = `calc(${iconSize} + ${iconPad * 2}px)`;

  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!hasValue) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      logger.log(`${label} copied to clipboard:`, value);
    } catch (err) {
      logger.error(`Failed to copy ${label}:`, err);
    }
  };

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, maxWidth: '100%', minWidth: 0, verticalAlign: 'middle' }}>
      {showValue && (
        <span style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          minWidth: 0,
        }}>
          {hasValue ? value : <span style={{ color: '#888', fontStyle: 'italic', fontSize: size === 'small' ? '0.875rem' : size === 'medium' ? '1rem' : '1.125rem' }}>{fallbackText}</span>}
        </span>
      )}
      {hasValue && (
        <Tooltip
          title={copied ? 'Copied to clipboard!' : `Copy ${label}`}
          placement="bottom"
          disableInteractive
        >
          <Box
            component="button"
            type="button"
            aria-label={`Copy ${label}`}
            onClick={handleCopy}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 'none',
              width: hitSize,
              height: hitSize,
              minWidth: hitSize,
              p: 0,
              border: 0,
              background: 'none',
              color: 'inherit',
              lineHeight: 0,
              cursor: 'pointer',
              borderRadius: '4px',
              '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)' },
            }}
          >
            <ContentCopyIcon sx={{ fontSize: iconSize, pointerEvents: 'none' }} />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default CopyableIdCell;
